import { FormValidationRule } from "../types";

const numbersOnly: FormValidationRule = (c, v) => {
    const valid = !(
        (c.field_boi_text_as_number || c.numbersOnly) &&
        v &&
        (isNaN(parseFloat(v)) || !isFinite(v))
    );
    return [valid, c.errorMessage || "You've entered an invalid character."];
};

export default numbersOnly;
